import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { MessageCircle, BedDouble } from "lucide-react";
import { api, brl, publicMedia } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function PublicLink() {
  const { slug, type, code } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/public/links/${slug}/${type}/${code}`).then((r) => {
      setD(r.data);
      if (r.data.wa_url && !r.data.property) setTimeout(() => { window.location.href = r.data.wa_url; }, 1200);
    }).catch(() => setErr("Link não encontrado ou desativado."));
  }, [slug, type, code]);
  if (err) return <div className="min-h-screen grid place-items-center text-muted-foreground" data-testid="public-link-error">{err}</div>;
  if (!d) return <div className="min-h-screen grid place-items-center text-muted-foreground">Abrindo...</div>;
  const p = d.property;
  const logo = d.tenant.branding?.logo_file_id;
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="w-full max-w-md rounded-2xl border bg-card overflow-hidden shadow-xl" data-testid="public-link-card">
        <div className="p-5 flex items-center gap-3 bg-[#073B2B] text-white">
          {logo ? <img src={publicMedia(logo)} alt="" className="h-10 w-10 rounded bg-white object-contain p-1" /> : <div className="h-10 w-10 rounded bg-[#D4AF37] grid place-items-center text-[#073B2B] font-bold">{d.tenant.name[0]}</div>}
          <span className="font-heading font-semibold">{d.tenant.branding?.display_name || d.tenant.name}</span>
        </div>
        {p && (
          <div>
            {p.main_media_id && <img src={publicMedia(p.main_media_id)} alt={p.title} className="h-56 w-full object-cover" />}
            <div className="p-5">
              <div className="font-mono text-xs text-muted-foreground">{p.code}</div>
              <h1 className="font-heading text-xl font-bold mt-1">{p.title}</h1>
              <div className="text-sm text-muted-foreground mt-1">{p.neighborhood}, {p.city}</div>
              <div className="flex items-center justify-between mt-3"><span className="font-heading text-2xl font-bold text-primary dark:text-accent">{p.status === "disponivel" ? brl(p.price) : "Indisponível"}</span><span className="text-sm flex items-center gap-1"><BedDouble className="h-4 w-4" />{p.bedrooms}</span></div>
            </div>
          </div>
        )}
        <div className="p-5 pt-0 space-y-3">
          {!p && <p className="text-sm text-muted-foreground pt-5">Redirecionando para o WhatsApp...</p>}
          {d.wa_url ? (
            <a href={d.wa_url} data-testid="public-link-whatsapp-button"><Button className="w-full h-12 bg-[#25D366] hover:bg-[#1ebe5b] text-white font-semibold"><MessageCircle className="h-5 w-5 mr-2" />Falar no WhatsApp</Button></a>
          ) : <p className="text-sm text-destructive">WhatsApp da imobiliária ainda não configurado.</p>}
          <p className="text-[11px] text-muted-foreground text-center">Você será atendido pela assistente virtual da imobiliária. <a href={`/privacidade/${slug}`} className="underline">Aviso de privacidade</a></p>
        </div>
      </div>
    </div>
  );
}
